import {
  Sidebar,
  SidebarItem,
  SidebarDivider,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import HomeIcon from '@material-ui/icons/Home';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

/**
 * The approved Mumzworld sidebar — a short, fully custom, static nav list
 * (not derived from Backstage's auto-discovered page extensions, which is
 * why Catalog/APIs/Catalog Graph/Register Existing Component never appear
 * here even though those pages/routes still exist and are reachable by
 * direct URL for internal/admin use).
 */
export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: () => (
      <Sidebar>
        <div style={{ padding: '20px 24px 12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: 8,
                background: '#5b5fef',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: 15,
              }}
            >
              M
            </div>
            <span style={{ fontWeight: 700, fontSize: 15, color: '#fff' }}>Mumzworld</span>
          </div>
          <div style={{ fontSize: 12, color: '#b3b7c2', marginTop: 2, marginLeft: 36 }}>
            Internal App Platform
          </div>
        </div>
        <SidebarDivider />
        <SidebarItem icon={HomeIcon} to="/" text="Home" />
        <SidebarItem icon={ViewModuleIcon} to="/applications" text="My apps" />
        <SidebarSpace />
        <SidebarDivider />
        <SidebarItem icon={HelpOutlineIcon} to="/help" text="Help" />
      </Sidebar>
    ),
  },
});
